<template>
  <div class="admin__home">
    <Header />
    <div class="admin__home--left-div">
      <Sidebar :item="item" :recruit="recruit" />
    </div>
    <div class="admin__home--right-div">
      <div class="hire">
        <div class="hire_body">
          <span>Hire Candidates</span>
          <p>What role do you want to hire for?</p>
          <div class="hire_body__dropdown">
            <div class="hire_body_role">
              <select v-model="selectedRole">
                <option value="">Select Role</option>
                <option v-for="(role, index) in roles" :value="role.id">{{role.name}}</option>
              </select>
            </div>
            <div class="hire_body_state">
              <select v-model="selectedState">
                <option value="">Select State</option>
                <option :value="25">Lagos</option>
              </select>
            </div>
            <div class="hire_body_lga">
              <select v-model="selectedCity">
                <option value="">Select Local Government</option>
                <option v-for="(city, index) in cities" :value="city.id">{{city.name}}</option>
              </select>
            </div>
          </div>
          <div class="hire_body__btn">
            <div @click.prevent="listCandidates">
              Search&nbsp;
              <font-awesome-icon icon="search" />
            </div>
          </div>
        </div>
        <div style="width: 55px;margin: 50px auto;" v-show="loading">
          <PageLoader />
        </div>
        <div class="hire_result" v-show="searchRes.length > 0">{{ searchRes.length > 0 ? searchRes.length : 'No'}} Results Found:</div>
        <div class="hire_table">
          <div v-for="(res, num) in searchRes" :key="num">
            <div class="hire_table_banner">
              <div class="hire_table_avatar">
                <div>
                  <!-- <img src="./../../../assets/images/leave.png" alt /> -->
                  {{res.avatar}}
                </div>
              </div>
              <div class="hire_table_name">
                <!-- Victor -->
                {{res.users.firstname}}
                <!-- <span>A.</span> -->
                <span>{{res.users.lastname}}</span>
              </div>
              <div class="hire_table_profile">
                <div @click="showDetails(num)">View Profile</div>
              </div>
              <div class="hire_table_interview">
                <div @click="showInterviewInviteModal">Invite for Interview</div>
              </div>
              <div class="hire_table_hire">
                <div @click.prevent="showHireCandidateModal">Hire Candidate</div>
              </div>
            </div>
            <div class="hire_table_details">
              <p>
                <span @click="hireDetails(num)">
                  <font-awesome-icon icon="times" />
                </span>
              </p>
              <div>
                <div>
                  <span>Gender:</span>
                  <p>{{res.users.gender}}</p>
                  <!-- <p>Male</p> -->
                </div>
                <div>
                  <span>Last Role Worked::</span>
                  <p>{{roles[roles.findIndex(role => role.id === res.jobrole_id)]["name"]}}</p>
                  <!-- <p>Sales Assistant</p> -->
                </div>
                <div>
                  <span>Last Salary Collected::</span>
                  <p>&#8358;{{res.current_pay.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}}</p>
                  <!-- <p>N150,000</p> -->
                </div>
                <div>
                  <span>Years of Experience::</span>
                  <p>{{res.experience_years}}</p>
                  <!-- <p>3</p> -->
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="hire_modal" v-if="hireModal">
          <div>
            <div class="hire_modal_content">
              <p>
                <span @click.prevent="hireModal = false">
                  <font-awesome-icon icon="times" />
                </span>
              </p>
              <img src="./../../../assets/images/bb.jpg" alt="Hire" />
              <div>
                <span>Hire this Candidate</span>
                <p>
                  - Candidate profile is moved to your inactive staff list, you
                  can activate there.
                  <br />- The candidate will be moved from the pool. Candidate
                  would be returned if not activated in 48 hours. <br />- All
                  your transferred history can be viewed under transferred
                  candidates. <br />- Candidate would be notified of the
                  activity.
                </p>
                <div @click.prevent="hireCandidate">Transfer Candidate</div>
              </div>
            </div>
          </div>
        </div>

        <div class="hire_modal" v-if="formModal">
          <div>
            <div class="form_modal_content">
              <p>
                <span @click.prevent="formModal = false">
                  <font-awesome-icon icon="times" />
                </span>
              </p>
              <img src="./../../../assets/images/suc.svg" alt="success" />
              <div>
                <p>
                  An email and SMS will be sent to the candidate. Please confirm
                  when you want the candidate to show up for the interview.
                </p>
                <div>
                  <form @submit.prevent="interviewInvite">
                    <div>
                      <div class="form_modal_text">Select Date:</div>
                      <div class="form_modal_input">
                        <!-- <select>
                          <option>tap to select date</option>
                        </select> -->
                        <input type="date" v-model="invite.interview_date" />
                      </div>
                    </div>
                    <div>
                      <div class="form_modal_text">Time:</div>
                      <div class="form_modal_input">
                        <!-- <select>
                          <option>tap to select time</option>
                        </select> -->
                        <input type="time" v-model="invite.interview_time" />
                      </div>
                    </div>
                    <div>
                      <div class="form_modal_text">Venue:</div>
                      <div class="form_modal_input">
                        <input type="text" v-model="invite.interview_venue"/>
                      </div>
                    </div>
                    <!--<div>
                      <div class="form_modal_text">Phone Number:</div>
                      <div class="form_modal_input">
                        <input type="text" />
                      </div>
                    </div> -->
                    <div>
                      <div class="form_modal_text"></div>
                      <div class="form_modal_input">
                        <button type="submit">Submit</button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../../partials/header";
import Sidebar from "../../partials/sidebar";
import * as types from "../../../store/constant";
import PageLoader from "../../partials/page-loader";

export default {
  name: "Hired",

  components: {
    Header,
    Sidebar,
    PageLoader
  },

  data() {
    return {
      item: "hire",
      recruit: "recruit",
      searchRes: [],
      hireModal: false,
      formModal: false,
      roles: [],
      states: [],
      cities: [],
      selectedRole: "",
      selectedCity: "",
      selectedState: "",
      invite: {},
      countryId: "",
      stateId: "",
      loading: false
    };
  },
  metaInfo: {
    title: 'Hire - hrdesk',
    meta: [
      { name: 'description', content: 'Explore job opportunities and join hrdesk\'s team.' },
      { property: 'og:title', content: 'Hire - hrdesk' },
      { property: 'og:description', content: 'Explore job opportunities and join hrdesk\'s team.' },
      { property: 'og:type', content: 'website' },
      { property: 'og:url', content: 'https://app.hrdesk.africa/hire' },
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:title', content: 'Hire - hrdesk' },
      { name: 'twitter:description', content: 'Explore job opportunities and join hrdesk\'s team.' },
      { name: 'twitter:image:alt', content: 'Hire at hrdesk' },
    ]
  },
  created() {
    this.getRoles();
    this.getCountry();
    this.getStates();
    this.getCities();
  },

  methods: {
    hireDetails(num) {
      const emp = document.querySelectorAll(".hire_table_details");
      emp[num].style.display = "none";
    },
    showDetails(num) {
      const emp = document.querySelectorAll(".hire_table_details");
      emp[num].style.display = "block";
    },
    showHireCandidateModal() {
      this.hireModal = true;
    },
    showInterviewInviteModal() {
      this.formModal = !this.formModal;
    },   
    getRoles() {
      this.$http.get(types.GET_JOB_ROLES)
        .then(resp => {
          this.roles = resp.data.data;
        })
    },
    getCountry() {
      this.$http.get(types.COUNTRY_API)
        .then(resp => {
          const response = JSON.parse(resp.data.data);
          this.countryId = response[0].id;
        })
    },
    getStates() {
      this.$http.get(`${types.STATE_API}/${160}`)
        .then(resp => {
          this.states = resp.data.data;
        })
    },    
    getCities() {
      this.$http.get(`${types.GET_CITIES}/${25}`)
        .then(resp => {
          this.cities = resp.data.data;
        })
    },
    // changeLocation(selectedState) {
    //   this.selectedState = selectedState;
    // },
    listCandidates() {
      this.loading = true;
      const payload = {
        role: this.selectedRole,
        state: this.selectedState,
        local_government: this.selectedCity
      };

      this.$http.post(`${types.GET_PROFILE}/search`, payload)
        .then(resp => {
          this.searchRes = resp.data.data.data;
          this.loading = false;
        })
        .catch(err => {
          this.searchRes = [];
          this.loading = false;
        })
    },
    interviewInvite() {
      if (Object.keys(inviteData).length !== 0) {
        const companyId = this.$store.getters.currentAuthUser.employees
          .company_id;

        this.inviteData.company_id = companyId;

        this.$http.post(`${types.GET_PROFILE}/invite`, this.inviteData)
        .then(resp => {
          this.searchRes = resp.data.data.data;
        })
        .catch(err => {
          this.searchRes = [];
        })         
      }
    },
    hireCandidate() {
      //post request for transferring candidates from jobseeker to employee
    }
  }
};
</script>
<style lang="scss" scoped>
.hire {
  padding-top: 56px;
  padding-left: 3.125vw;
  padding-right: 3.125vw;

  > .hire_body {
    text-align: center;

    > span {
      font-size: 22px;
      font-weight: 600;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.18;
      letter-spacing: normal;
      text-align: center;
      color: #000000;
    }

    > p {
      font-size: 16px;
      font-weight: 300;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.25;
      letter-spacing: normal;
      text-align: center;
      color: #000000;
      margin-top: 10px;
    }

    > .hire_body__dropdown {
      max-width: 700px;
      margin: 30px auto;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      align-items: center;
      justify-content: center;
      align-content: center;
      border-radius: 20px;
      box-shadow: 0 10px 4px 0 rgba(0, 0, 0, 0.1);
      border: solid 1px rgba(199, 199, 199, 0.4);
      background-color: #ffffff;

      > .hire_body_role {
        width: 40%;
        padding: 10px;

        > select {
          height: 40px;
          border: 0;
          outline: 0;
          font-size: 14px;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.17;
          letter-spacing: normal;
          text-align: left;
          color: #000000;
        }
      }

      > .hire_body_state {
        width: 30%;
        padding: 10px;
        border-left: solid 1px rgba(199, 199, 199, 0.4);
        border-right: solid 1px rgba(199, 199, 199, 0.4);

        > select {
          height: 40px;
          border: 0;
          outline: 0;
          font-size: 14px;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.17;
          letter-spacing: normal;
          text-align: left;
          color: #000000;
        }
      }

      > .hire_body_lga {
        width: 30%;
        padding: 10px;

        > select {
          height: 40px;
          border: 0;
          outline: 0;
          font-size: 14px;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.17;
          letter-spacing: normal;
          text-align: left;
          color: #000000;
        }
      }
    }

    > .hire_body__btn {
      > div {
        width: 200px;
        height: 40px;
        border-radius: 5px;
        background-color: #5099de;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.18;
        letter-spacing: normal;
        text-align: center;
        color: #ffffff;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: center;
        align-content: center;
        margin: auto;
        cursor: pointer;
      }
    }
  }

  > .hire_result {
    font-size: 14px;
    font-weight: 300;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.25;
    letter-spacing: normal;
    text-align: left;
    color: #f79320;
    text-decoration: underline;
    margin: 30px 0;
  }

  > .hire_table {
    > div {
      border-radius: 2px;
      overflow: hidden;
      background-color: #ffffff;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
      margin-bottom: 50px;

      > .hire_table_banner {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: center;
        align-content: center;
        padding: 20px 10px;

        > .hire_table_avatar {
          width: 100px;
          > div {
            width: 50px;
            height: 50px;
            border-radius: 60px;
            overflow: hidden;
            background-color: #ccc;
          }
        }

        > .hire_table_name {
          width: calc(100% - 700px);
          font-size: 16px;
          font-weight: 200;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.18;
          letter-spacing: normal;
          text-align: left;
          color: #000000;

          > span {
            font-weight: 600;
          }
        }

        > .hire_table_profile {
          width: 200px;

          > div {
            width: 70%;
            padding: 7px 0;
            border-radius: 5px;
            border: solid 1px #c7c7c7;
            background-color: #ffffff;
            font-size: 13px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: 2.22;
            letter-spacing: normal;
            text-align: center;
            color: #000000;
            margin: auto;
            cursor: pointer;
          }
        }

        > .hire_table_interview {
          width: 200px;

          > div {
            width: 70%;
            padding: 7px 0;
            border-radius: 5px;
            border: solid 1px #c7c7c7;
            background-color: #ffffff;
            font-size: 13px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: 2.22;
            letter-spacing: normal;
            text-align: center;
            color: #000000;
            margin: auto;
            cursor: pointer;
          }
        }

        > .hire_table_hire {
          width: 200px;

          > div {
            width: 70%;
            padding: 7px 0;
            border-radius: 5px;
            border: solid 1px #c7c7c7;
            background-color: #ffffff;
            font-size: 13px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: 2.22;
            letter-spacing: normal;
            text-align: center;
            color: #000000;
            margin: auto;
            cursor: pointer;
          }
        }
      }
      > .hire_table_details {
        border-radius: 2px;
        padding: 10px;
        display: none;

        > p {
          text-align: right;

          > span {
            color: #000;
            cursor: pointer;
          }
        }

        > div {
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          align-items: center;
          justify-content: center;
          align-content: center;

          > div {
            padding-left: 50px;
            border-right: 1px solid #c7c7c7;

            > span {
              font-size: 14px;
              font-weight: normal;
              font-stretch: normal;
              font-style: normal;
              line-height: 2.1;
              letter-spacing: normal;
              text-align: center;
              color: #000000;
            }

            > p {
              font-size: 16px;
              font-weight: normal;
              font-stretch: normal;
              font-style: normal;
              line-height: 1.68;
              letter-spacing: normal;
              text-align: left;
              color: #5099de;
            }
          }

          > div:nth-child(4) {
            border-right: 0;
          }
        }
      }
    }
  }

  > .hire_modal {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.6);
    overflow: auto;

    > div {
      max-width: 800px;
      margin: 150px auto 50px auto;

      > .hire_modal_content {
        border-radius: 2px;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
        background-color: #ffffff;
        padding: 50px;
        text-align: center;

        > p {
          text-align: right;

          > span {
            color: #000;
            cursor: pointer;
          }
        }

        > img {
          width: 70px;
        }

        > div {
          text-align: left;

          > span {
            font-stretch: normal;
            font-style: normal;
            line-height: 2.08;
            letter-spacing: normal;
            text-align: left;
            color: #000000;
            font-size: 18px;
            font-weight: 500;
            text-decoration: underline;
          }

          > p {
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: 2.08;
            letter-spacing: normal;
            text-align: left;
            color: #000000;
            margin: 30px 0;
          }

          > div {
            width: 200px;
            height: 40px;
            border-radius: 5px;
            background-color: #5099de;
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.21;
            letter-spacing: normal;
            text-align: center;
            color: #ffffff;
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            align-items: center;
            justify-content: center;
            align-content: center;
            cursor: pointer;
          }
        }
      }

      > .form_modal_content {
        border-radius: 2px;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
        background-color: #ffffff;
        padding: 10px 70px 150px 70px;
        text-align: center;

        > p {
          text-align: right;

          > span {
            color: #000;
            cursor: pointer;
          }
        }

        > img {
          width: 70px;
        }

        > div {
          text-align: left;

          > p {
            font-size: 16px;
            font-weight: 600;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.43;
            letter-spacing: normal;
            text-align: center;
            color: #000000;
            margin: 30px 0;
            padding: 0 20px;
          }

          > div {
            max-width: 400px;
            margin: auto;

            > form {
              > div {
                display: flex;
                flex-direction: row;
                flex-wrap: nowrap;
                align-items: center;
                justify-content: center;
                align-content: center;
                margin-bottom: 20px;

                > .form_modal_text {
                  width: 100px;
                  font-size: 14px;
                  font-weight: normal;
                  font-stretch: normal;
                  font-style: normal;
                  line-height: 1.17;
                  letter-spacing: normal;
                  text-align: left;
                  color: #707070;
                }

                > .form_modal_input {
                  width: calc(100% - 100px);

                  overflow: hidden;

                  > select {
                    height: 40px;
                    border: 0;
                    outline: 0;
                    padding: 0 5px;
                    font-size: 13px;
                    font-weight: normal;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: 1.22;
                    letter-spacing: normal;
                    text-align: left;
                    color: #000000;
                    border: solid 1px #c7c7c7;
                    border-radius: 3px;
                    margin-bottom: 10px;
                  }

                  > input {
                    height: 40px;
                    border: 0;
                    outline: 0;
                    padding: 0 5px;
                    font-size: 13px;
                    font-weight: normal;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: 1.22;
                    letter-spacing: normal;
                    text-align: left;
                    color: #000000;
                    border: solid 1px #c7c7c7;
                    border-radius: 3px;
                  }

                  > button {
                    border-radius: 5px;
                    background-color: #5099de;
                    width: 200px;
                    margin: auto;
                    height: 40px;
                    border: 0;
                    outline: 0;
                    font-weight: normal;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: 1.21;
                    letter-spacing: normal;
                    text-align: center;
                    color: #ffffff;
                    font-size: 13px;
                    margin-top: 10px;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
